export { default as GridLayout } from './MainPanel';
//# sourceMappingURL=index.js.map